import Vue from 'vue'
import Vuex from 'vuex'
// import RouterModule from "./modules/router"
// import UserModule from "./modules/user"

Vue.use(Vuex)

export default new Vuex.Store({})
